export default __webpack_public_path__ + "static/media/dog-dancing-media.ccb38efa.png";